
<ng-container class="navbar-nav ms-auto p-4 p-lg-0" *ngIf="webApi.isLoggedIn() else normalmenu">
    <!-- <a [routerLink]="['/video']" class="nav-item nav-link active">VIDEO LIBRARY</a> -->
    <div class="dropdown">
      <a href="#" class="nav-item nav-link dropdown-toggle"  data-bs-auto-close="true"
      data-bs-toggle="dropdown" data-bs-offset="50,20" aria-expanded="false" >VIDEO LIBRARY</a>
      <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenu">
        <li><a class="dropdown-item" [routerLink]="['/video']">Video Library</a></li>
        <li><a class="dropdown-item" data-bs-toggle="modal" data-bs-target="#suggest-skill" href="javascript:void(0)">Suggest a Skill</a></li>
      </ul>
    </div>
    <a [routerLink]="['/dashboard']" class="nav-item nav-link">DASHBOARD</a>
    <a [routerLink]="['/series']" class="nav-item nav-link">SIGNATURE SERIES</a>
    <!-- <div class="dropdown">
      <a href="#" class="nav-item nav-link dropdown-toggle"  data-bs-auto-close="true"
      data-bs-toggle="dropdown" data-bs-offset="50,20" aria-expanded="false" >DASHBOARD</a>
      <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenu">
        <li><a class="dropdown-item" [routerLink]="['/dashboard']">Dashboard</a></li>
        <li><a class="dropdown-item" href="javascript:void(0)" data-bs-toggle="modal" data-bs-target="#subscription-update-modal">My Subscription</a></li>
        <li><a class="dropdown-item" data-bs-toggle="modal" data-bs-target="#suggest-skill" href="javascript:void(0)">Suggest a Skill</a></li>
      </ul>
    </div> -->
    <!-- <a [routerLink]="['/profile']" class="nav-item nav-link">PROFILE</a> -->
    <div class="dropdown">
      <a href="#" class="nav-item nav-link dropdown-toggle"  data-bs-auto-close="true"
      data-bs-toggle="dropdown" data-bs-offset="50,20" aria-expanded="false" >PROFILE</a>
      <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenu">
        <li><a class="dropdown-item" [routerLink]="['/profile']">Profile</a></li>
        <li><a class="dropdown-item" href="javascript:void(0)" data-bs-toggle="modal" data-bs-target="#subscription-update-modal">My Subscription</a></li>
      </ul>
    </div>
    <!-- <a href="/" class="nav-item nav-link">LEARN</a> -->
    <app-contact-dropdown></app-contact-dropdown>
    <app-login-dropdown></app-login-dropdown>
</ng-container>
<ng-template #normalmenu>
<ng-container class="navbar-nav ms-auto p-4 p-lg-0">
    <a [routerLink]="['/']" class="nav-item nav-link active ft-wght-300">HOME</a>
    <a [routerLink]="['/signup']" class="nav-item nav-link">SIGN UP</a>
    <!-- <div class="dropdown">
      <a href="#" class="nav-item nav-link dropdown-toggle"  data-bs-auto-close="true"
      data-bs-toggle="dropdown" data-bs-offset="50,20" aria-expanded="false" >SIGN UP</a>
      <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton1">
        <li><a class="dropdown-item" [routerLink]="['/signup']">Gym Owner</a></li>
        <li><a class="dropdown-item" [routerLink]="['/signup-coach']">Coach</a></li>
      </ul>
    </div> -->
    <a routerLink="/series" class="nav-item nav-link">SIGNATURE SERIES</a>
    <a routerLink="/pricing" class="nav-item nav-link">PRICING</a>
    <app-contact-dropdown></app-contact-dropdown>
    <!-- <a href="/" class="nav-item nav-link">CONTACT</a>
    <a href="/" class="nav-item nav-link">LOGIN</a> -->

    <app-login-dropdown></app-login-dropdown>

</ng-container>
</ng-template>
